<template>
    <div class="popup" v-if="isShowStarJumpPopup">
        <div class="content" id="userStarJump">
            <div id="starJumpClose">
                <div class="icon-star-close" @click="closeStarJumpPopup()"></div>
            </div>
            <img id="starJumpImg" src="../../../assets/images/userStar/thank-you.svg" draggable="false">
            <div id="starJumpTitle">{{$t('language.popup.userStarPopup.thankYou')}}</div>
            <div id="starJumpDesc">{{$t('language.popup.userStarPopup.thankYouDesc')}}</div>
            <button id="starJumpBtn" @click="jumpToTrustpilot()">{{$t('language.popup.userStarPopup.reviewStart')}}<span></span>Trustpilot {{$t('language.popup.userStarPopup.reviewEnd')}}</button>
        </div>
    </div>
</template>

<script>
import taskListUtils from "@/js/workspace/task_list_util.js";
export default {
    data() {
        return {
            // 是否显示弹窗
            isShowStarJumpPopup: false
        }
    },
    methods: {
        // 关闭
        closeStarJumpPopup() {
            this.isShowStarJumpPopup = false;
        },
        // 跳转
        jumpToTrustpilot() {
            window.open("https://www.trustpilot.com/evaluate/multcloud.com");
            taskListUtils.userStarUpdateRequest({createReason:1,trustpilot:true});
        }
    }
}
</script>

<style>
#userStarJump {
     width: 400px;
     height: 360px;
     border-radius: 16px;
     text-align: center;
     border: 1px solid #FFF;
     font-family: "Segoe UI", "Arial", "Microsoft YaHei", "微软雅黑";
}
/* 关闭 */
#starJumpClose {
    position: absolute;
    z-index: 1;
    right: 8px;
    top: 8px;
}
#starJumpClose>.icon-star-close {
    width: 40px;
    height: 40px;
    display: inline-block;
    background-image: url("../../../assets/images/userStar/icon-close.svg");
    background-position: 0px 0px;
    cursor: pointer;
}
#starJumpClose>.icon-star-close:hover {
    background-image: url("../../../assets/images/userStar/icon-close-hover.svg");
}
#starJumpClose>.icon-star-close:active {
    opacity: 0.8;
}
/* 图标 */
#starJumpImg {
    margin-top: 40px;
}
/* 标题 */
#starJumpTitle {
    font-size: 20px;
    font-weight: bolder;
    margin: 20px 0;
}
/* 描述 */
#starJumpDesc {
    margin: 0 30px 20px 30px;
    text-align: left;
    line-height: 18px;
    font-size: 14px;
}
/* 跳转按钮 */
#starJumpBtn {
    font-family: "Segoe UI", "Arial", "Microsoft YaHei", "微软雅黑";
    padding: 6px 24px !important;
    border-radius: 4px;
    font-size: 16px;
    height: 36px;
}
#starJumpBtn>span {
    display: inline-block;
    vertical-align: middle;
    position: relative;
    top: -2px;
    margin: 0 4px;
    background-image: url("../../../assets/images/userStar/trustpilot.svg");
    height: 24px;
    width: 24px;
}
</style>


// WEBPACK FOOTER //
// src/components/popup/task_list_popups/user_star_jump_popup.vue